import URI from 'urijs';

export enum DisplayMode {
  Shellless = 'shellless',
  Default = 'default'
}

export function getDisplayMode(href = window.location.href): DisplayMode {
  const uri = new URI(href);
  const search = uri.search(true);
  const mode = search.DisplayMode;
  if (mode && Object.values(DisplayMode).includes(mode as DisplayMode)) {
    return mode as DisplayMode;
  }
  return DisplayMode.Default;
}
